// src/utils/languageHelper.js

const COOKIE_NAME = 'cliclaim_language';
const COOKIE_DOMAIN = '.cliclaim.com';
const LANGUAGE_DEFAULT = 'en';

export function setLanguage(lng) {
  // Save in localStorage (for convenience inside app)
  localStorage.setItem(COOKIE_NAME, lng);

  // Save in a cookie accessible to both guest/admin
  document.cookie = `${COOKIE_NAME}=${lng}; path=/; domain=${COOKIE_DOMAIN}; max-age=31536000; Secure; SameSite=None`;
}

export function getLanguage() {
  // Try cookie first (shared)
  const match = document.cookie.match(
    new RegExp('(^| )' + COOKIE_NAME + '=([^;]+)')
  );
  if (match) return match[2];

  // Fallback to localStorage or default
  return localStorage.getItem(COOKIE_NAME) || LANGUAGE_DEFAULT;
}
